export default __webpack_public_path__ + "static/media/BO.fcdfabc5.svg";